import React from 'react';
import { BLOCKS, Block, Inline } from '@contentful/rich-text-types';

import { IInfoBlockFields } from '../../../types/contentful';

import RichText from '../RichText';
import { EmbeddedEntryNode } from '../RichText/Nodes';
import { ScrollReveal } from '../ScrollReveal';
import { Asset } from '../AtomicComponents/Asset';

import { Asset as ContentfulAsset } from 'contentful';

export function InfoBlock({
  headingText,
  centerAlign,
  bodyCopy,
  upperLeftIcon,
  optionalBackgroundColor
}: IInfoBlockFields) {
  const textAlign = centerAlign ? 'text-center' : 'text-left';
  const bgColor = optionalBackgroundColor
    ? `#${optionalBackgroundColor}`
    : '#035C67';

  return (
    <ScrollReveal>
      <div
        className="block-container mb-12 mt-12 mobile:mb-1 mobile:mt-2 tablet:mb-16 tablet:mt-16"
        data-blockid="infoBlock"
        data-testid="infoBlock"
      >
        <div className="box-border flex w-full flex-1 flex-wrap items-center justify-center">
          <div
            className="h-full w-full rounded-[56px] p-0 px-2 tablet:mx-8 tablet:rounded-[64px] tablet:px-2 desktop:rounded-[104px]"
            style={{ backgroundColor: bgColor }}
          >
            {upperLeftIcon && (
              <div data-testid="gl-img">
                <Asset
                  asset={upperLeftIcon as ContentfulAsset}
                  loading="eager"
                  className="mr-[105px] mt-[25px] !h-auto max-w-[120px] min-[375px]:mr-[165px] min-[425px]:mr-[220px] tablet:mr-[475px] tablet:mt-[35px] desktop:mr-[690px] desktop:mt-[35px]"
                />
              </div>
            )}
            <div className="box-column w-full">
              <div
                className={`mx-auto flex flex-col-reverse items-center px-2 tablet:max-w-[880px] tablet:flex-row tablet:flex-nowrap ${textAlign}`}
              >
                <div
                  className={`w-full p-8 tablet:mx-auto tablet:w-auto tablet:pb-10 tablet:pt-10 ${textAlign}`}
                >
                  <div className="mb-4 desktop:mb-12">
                    <h2 className="text-[28px] font-medium leading-8 text-white desktop:text-[42px] desktop:leading-12">
                      {headingText}
                    </h2>
                  </div>
                  {bodyCopy && (
                    <div className="mb-6">
                      <RichText
                        data={bodyCopy}
                        colour="white"
                        bulletColor="green"
                        overrideOptions={{
                          [BLOCKS.LIST_ITEM]: (
                            node: Block | Inline,
                            children: any
                          ) => (
                            <li className="pl-[10px] [&>p]:mb-[15px] [&>p]:text-xs [&>p]:font-normal tablet:[&>p]:mb-[25px] tablet:[&>p]:text-xl">
                              {children}
                            </li>
                          ),
                          [BLOCKS.EMBEDDED_ENTRY]: (node, children) => (
                            <div className="my-4 flex items-center justify-center [&_button]:self-center">
                              <EmbeddedEntryNode
                                node={node}
                                colour="white"
                                width="auto"
                              >
                                {children}
                              </EmbeddedEntryNode>
                            </div>
                          )
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
